<template>
  <main>
    <div>
      <div class="md:flex">
        <div class="md:w-1/2">
          <InputField class="pb-[2.4rem]" v-model="name" :label="$t('Name')" :placeholder="$t('Name')"
            inputClass="input mt-4" :inputProps="{ autocomplete: 'given-name', name: 'given-name' }" />
        </div>
        <div class="md:w-1/2 md:pl-4">
          <InputField class="pb-[2.4rem]" v-model="lastname" :label="$t('Last Name')" :placeholder="$t('Last Name')"
            inputClass="input mt-4" :inputProps="{ autocomplete: 'family-name', name: 'family-name' }" />
        </div>
      </div>

      <InputField class="pb-[2.4rem]" v-model="email" :label="$t('Email *')" :placeholder="$t('Email *')"
        :required="true" ref="emailField" inputClass="input mt-4" inputType="email"
        :inputProps="{ autocomplete: 'email', name: 'email' }" />

      <InputField class="pb-[2.4rem]" v-model="password" :label="$t('Password *')" :placeholder="$t('Password *')"
        inputType="password" :required="true" ref="passwordField" inputClass="input mt-4"
        :inputProps="{ autocomplete: 'new-password', name: 'new-password' }" />

      <InputField class="pt_16" inputType="checkbox" v-model="okRss" ref="okRssField">
        {{ $t('I want to receive commercial communications from Medkus (optional).') }}
        <a href="#" class="underline">
          {{ $t('Learn more') }}
        </a>
      </InputField>

      <CustomButton :label="$t('Continue')" @click="validateForm" />
    </div>
    <div v-if="showError" class="text-red-600 text-[1.4rem] mb-4">
      {{ errorMessage }}
    </div>

    <div class="pt-[2.4rem]">
      <p class="text-black text-[1.4rem] md:text-[1.8rem]">
        {{ $t('Do you already have an account on Medkus?') }}
        <router-link to="/login" class="underline">
          {{ $t('Enter here') }}
        </router-link>
      </p>
    </div>
  </main>
  <CoreModal
    v-model="showModal"
    :title="$t('Check your email to confirm your account.')"
    :message="$t('We have sent a confirmation email. Check your inbox to activate your account.')"
    :close-on-overlay="false"
  >
    <template #actions>
      <CustomButton
        :label="$t('Go to login')"
        class="px-[4.8rem] py-[1.8rem] text-[1.8rem] font-medium"
        @click="goToLogin"
      />
    </template>
  </CoreModal>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from 'vue-router';
import InputField from '@/components/input/inputField.vue';
import CustomButton from '@/components/buttons/customButton.vue';
import CoreModal from '@/components/modal/CoreModal.vue';
import { register } from '@/services/medkusApi/publiccustomersService';

export default defineComponent({
  name: "RegisterView",
  components: {
    CustomButton,
    InputField,
    CoreModal
  },
  data() {
    return {
      name: '',
      lastname: '',
      email: '',
      password: '',
      okRss: false,

      showError: false,
      errorMessage: '',
      showModal: false,
    };
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  methods: {
    goToLogin() {
      this.router.push({ path: "/login", query: { registered: true } });
    },
    showLoginError(msg) {
      this.errorMessage = msg;
      this.showError = true;
    },
    validateForm() {
      this.$refs.emailField.updateValue({ target: { value: this.email } });
      this.$refs.passwordField.updateValue({ target: { value: this.password } });
      this.$refs.okRssField.updateValue({ target: { checked: this.okRss } });

      const isEmailInvalid = this.$refs.emailField.isInvalid;
      const isPasswordInvalid = this.$refs.passwordField.isInvalid;

      if (!isEmailInvalid && !isPasswordInvalid) {
        register({
          name: this.name,
          surname: this.lastname,
          email: this.email,
          phone: "",
          okRss: this.okRss,
          password: this.password
        })
          .then((response) => {
            if (response && response.ok) {
              this.showModal = true;
            } else {
              this.showLoginError((response && response.errorMsg) || this.$t('Register failed'));
            }
          })
          .catch(() => {
            this.showLoginError(this.$t('Register failed'));
          });
      }
    }
  }
});
</script>


<style scoped></style>
